if (!customElements.get('lotuscourt-category-strip')) {
  customElements.define('lotuscourt-category-strip', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.items = this.querySelector('.lc-category-strip__items');
      this.previous = this.querySelector('[data-direction="previous"]');
      this.next = this.querySelector('[data-direction="next"]');
      this.progress = this.querySelector('progress');
      if (!this.items) return;
      const scroll = direction => this.items.scrollBy({ left: direction * this.items.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      this.previous.addEventListener('click', () => scroll(-1), options);
      this.next.addEventListener('click', () => scroll(1), options);
      this.items.addEventListener('scroll', () => this.update(), options);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.items);
      this.update();
    }
    update() {
      const max = Math.max(0, this.items.scrollWidth - this.items.clientWidth);
      const position = Math.abs(this.items.scrollLeft);
      this.previous.disabled = position < 2;
      this.next.disabled = max < 2 || position >= max - 2;
      this.progress.value = max ? position / max : 1;
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  });
}
